var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "edit-version-box"
    },
    [
      _c(
        "el-dialog",
        { attrs: { title: "", visible: true, "before-close": _vm.closeBox } },
        [
          _vm.id == 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "100px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "系统类型:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "系统类型" },
                              model: {
                                value: _vm.form.sys_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "sys_type", $$v)
                                },
                                expression: "form.sys_type"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "后台ERP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "2", label: "仓储APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "3", label: "代采APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "4", label: "YS-APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "朱雀手持", value: "5" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否强制更新:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "是否强制更新" },
                              model: {
                                value: _vm.form.is_force_update,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "is_force_update", $$v)
                                },
                                expression: "form.is_force_update"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "0", label: "否" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "是" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版本号:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "版本号" },
                            model: {
                              value: _vm.form.version,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "version", $$v)
                              },
                              expression: "form.version"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新链接:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "更新链接" },
                            model: {
                              value: _vm.form.update_url,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "update_url", $$v)
                              },
                              expression: "form.update_url"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              attrs: {
                                action: _vm.uploadActionUrl,
                                data: _vm.uploadData,
                                "on-success": _vm.uploadSuccess,
                                "before-upload": _vm.beforeUpload,
                                limit: 1
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "mini", type: "primary" } },
                                [_vm._v("选择文件")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新说明:" } },
                        [
                          _c("el-input", {
                            staticClass: "version_box",
                            staticStyle: { width: "50%", height: "180px" },
                            attrs: {
                              type: "textarea",
                              placeholder: "更新说明"
                            },
                            model: {
                              value: _vm.form.update_desc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "update_desc", $$v)
                              },
                              expression: "form.update_desc"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.id > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "100px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "系统类型:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { disabled: "", placeholder: "系统类型" },
                              model: {
                                value: _vm.form.sys_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "sys_type", $$v)
                                },
                                expression: "form.sys_type"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "后台ERP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "2", label: "仓储APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "3", label: "代采APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "4", label: "YS-APP" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "朱雀手持", value: "5" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否强制更新:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "是否强制更新" },
                              model: {
                                value: _vm.form.is_force_update,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "is_force_update", $$v)
                                },
                                expression: "form.is_force_update"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "0", label: "否" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "是" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版本号:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "版本号" },
                            model: {
                              value: _vm.form.version,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "version", $$v)
                              },
                              expression: "form.version"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新链接:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "更新链接" },
                            model: {
                              value: _vm.form.update_url,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "update_url", $$v)
                              },
                              expression: "form.update_url"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-upload", {
                            ref: "upload",
                            attrs: {
                              action: _vm.action,
                              limit: 1,
                              "on-success": _vm.uploadSuccess,
                              "auto-upload": true,
                              "with-credentials": ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新说明:" } },
                        [
                          _c("el-input", {
                            staticClass: "version_box",
                            staticStyle: { width: "50%", height: "180px" },
                            attrs: {
                              type: "textarea",
                              placeholder: "更新说明"
                            },
                            model: {
                              value: _vm.form.update_desc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "update_desc", $$v)
                              },
                              expression: "form.update_desc"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50b4f030", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b4f030","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting/components/VersionInfo.vue
// module id = null
// module chunks = 